import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { INoRowsOverlayParams } from 'ag-grid-community';
import {
  BehaviorSubject,
  Observable,
  Subject,
} from 'rxjs';
import {
  delay,
  filter,
  takeUntil
} from 'rxjs/operators';
import { selectSubAccountId } from '../../../account-info-header/reducers';
import { TransactionsTableActions, WireActions } from '../../../create-request/actions';
import {
  selectTransactionsTableState,
} from '../../../create-request/reducers';
import { TableComponentState } from '../../types/TableComponentState';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { selectConfirmationPage } from '../../reducers';
import { NoRowsFunctionInfo } from '../../types/NoRowsFunctionInfo';
import {NoRowsMessageTemplates, transactionTableTabs} from '../../utilities/Constants';

@Component({
  standalone: false,
  selector: 'mm-custom-error-transaction-table',
  templateUrl: './custom-error-transaction-table.component.html',
  styleUrls: ['./custom-error-transaction-table.component.scss'],
})
export class CustomErrorTransactionTableComponent
  implements OnInit, OnDestroy, INoRowsOverlayAngularComp
{
  params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  };
  tableState = new BehaviorSubject<TableComponentState>({
    isInitialLoad: false,
    gridReady: false,
    printClicked: false,
    hasEmptyResponse: false,
    loading: false,
    hasError: false,
    error: '',
  });
  tableState$ = this.tableState.asObservable();
  accountId: string;
  viewTransactionStatusClicked: boolean;
  createAnotherRequestClicked: boolean;
  private destroy$ = new Subject<void>();
  currentTab: string;
  isTemplatesTab: boolean;
  spinner$: Observable<boolean>;
  showSpinner = new BehaviorSubject<{ loading: boolean }>({
    loading: false,
  });
  showSpinner$ = this.showSpinner.asObservable();
  obs: Observable<{ loading: false }>;
  tableName: string;
  tableTabName: string;
  noRowsMessageTemplates = NoRowsMessageTemplates;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.tableState$ = this.store.select(selectTransactionsTableState);

    this.isTemplatesTab = this.tableTabName === transactionTableTabs.templates;

    if (this.tableName !== 'templates') {
      this.store
        .select(selectTransactionsTableState)
        .pipe(takeUntil(this.destroy$))
        .subscribe((val) => {
          this.tableState.next(val);
        });
    }

    this.store.select(selectTransactionsTableState)
      .pipe(
        takeUntil(this.destroy$),
        filter(
          (tableState) =>
            this.tableName === 'templates'
        ),
        delay(2000)
      )
      .subscribe((tableState) => {
        if (tableState.loading) {
          this.showSpinner.next({ loading: tableState.loading })
        }
        else {
          this.showSpinner.next({ loading: tableState.loading });
        }
      });

    this.store
      .pipe(takeUntil(this.destroy$), select(selectSubAccountId))
      .subscribe((id) => (this.accountId = id));

    this.store
      .pipe(takeUntil(this.destroy$), select(selectConfirmationPage))
      .subscribe((confirmationPage) => {
        this.viewTransactionStatusClicked =
          confirmationPage.viewTransactionStatusClicked;
        this.createAnotherRequestClicked =
          confirmationPage.createAnotherRequestClicked;
      });
  }

  ngOnDestroy(): void {
    this.destroy$?.next();
    this.destroy$?.unsubscribe();
  }

  agInit(
    params: INoRowsOverlayParams & { noRowsMessageFn: () => NoRowsFunctionInfo  }
  ): void {
    this.params = params;
    this.tableName = this.params.noRowsMessageFn().tableName;
    this.tableTabName = this.params.noRowsMessageFn().tableTabName;
  }

  refreshTemplates() {
    this.store.dispatch(WireActions.callWireTemplatesGetListTable());
  }

  refreshAccount(accountId: string): void{
    this.store.dispatch(TransactionsTableActions.refresh({ accountId: accountId }));
  }

  sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  get tableItemInContext(): string {
    return this.isTemplatesTab ? 'templates' : this.tableName;
  }
}
